export default {
    namespaced: true,
    state: {
      services: [
        {
          id: 100,
          title: 'Antrag auf Ausbildungsförderung (BAföG)',
          authority: 'Schulverwaltungsamt Augsburg',
          online: true,
          duration: 13,
          description: '',
          iconName: 'augsburg',
          relatedServices: [101,102,103,104],
          doneBy: [],
          sections: [{
              name: 'Personenbezogene Angaben',
              description: 'Angaben zum Studium, zum Wohnsitz, zu Versicherungen etc.',
              icon: 'personalData',
              fields: 7,
            },
            {
              name: 'Schulischer & beruflicher Werdegang',
              description: 'Ihre bisherige schulische und betriebliche Ausbildung, Praktika etc.',
              icon: 'education',
              fields: 2,
            },
            {
              name: 'Angaben zum Einkommen & Vermögen',
              description: 'Z.B. Praktikumsvergütung, Mini-Job, Waisenrente, Kapitalvermögen etc.',
              icon: 'finance',
              fields: 3,
            },
            {
              name: 'Angaben der Eltern / Ehepartner / Lebenspartner',
              description: 'Angaben zu den Personen, Einkommensnachweise, Kapitalerträge etc.',
              icon: 'parents',
              fields: 7,
            }
          ],
        },  
        {
          id: 101,
          title: 'Abmeldung ins Ausland',
          authority: 'Finanzamt',
          online: false,
          duration: 12,
          description: '',
          iconName: 'migration',
          doneBy: [],
          relatedServices: [105,102,103,104],
          sections: [],
        },
        {
          id: 102,
          title: 'Antragsstatus Ausweis / Pass',
          authority: 'Bürgerbüro Augsburg',
          online: true,
          duration: 6,
          description: '',
          iconName: 'augsburg',
          doneBy: [],
          relatedServices: [101,105,103,104],
          sections: [],
        },
        {
          id: 103,
          title: 'Bewohnerparkausweis',
          authority: 'Verkehrsamt',
          online: false,
          duration: 3,
          description: '',
          iconName: 'car',
          doneBy: [],
          relatedServices: [101,102,105,104],
          sections: [],
        },
        {
          id: 104,
          title: 'Briefwahlunterlagen',
          authority: 'Bürgerbüro',
          online: true,
          duration: 7,
          description: '',
          iconName: 'augsburg',
          doneBy: [],
          relatedServices: [101,102,103,105],
          sections: [],
        },
        {
          id: 105,
          title: 'Führungszeugnis',
          authority: 'Bürgerbüro',
          online: false,
          duration: 7,
          description: '',
          iconName: 'certificate',
          doneBy: [],
          relatedServices: [101,102,103,104],
          sections: [],
        },
        {
          id: 106,
          title: 'Feinstaubplakette',
          authority: 'Verkehrsamt',
          online: false,
          duration: 12,
          description: '',
          iconName: 'car',
          doneBy: [],
          relatedServices: [105,102,103,104],
          sections: [],
        },
        {
          id: 108,
          title: 'Geburtsurkunde',
          authority: 'Einwohnermeldeamt',
          online: true,
          duration: 6,
          description: '',
          iconName: 'children',
          doneBy: [],
          relatedServices: [101,105,103,104],
          sections: [],
        },
        {
          id: 109,
          title: 'Gewerbe-Anmeldung',
          authority: 'Finanzamt',
          online: false,
          duration: 6,
          description: '',
          iconName: 'spacecraft',
          doneBy: [],
          relatedServices: [101,102,105,104],
          sections: [],
        },
        {
          id: 110,
          title: 'Punkteauskunft',
          authority: 'Verkehrsamt',
          online: true,
          duration: 2,
          description: '',
          iconName: 'car',
          doneBy: [],
          relatedServices: [101,102,103,105],
          sections: [],
        },
        {
          id: 111,
          title: 'Meldebescheinigung',
          authority: 'Einwohnermeldeamt',
          online: false,
          duration: 7,
          description: '',
          iconName: 'certificateFile',
          doneBy: [],
          relatedServices: [101,102,103,104],
          sections: [],
        },
        {
          id: 112,
          title: 'Wunschkennzeichen',
          authority: 'Verkehrsamt',
          online: false,
          duration: 6,
          description: '',
          iconName: 'car',
          doneBy: [],
          relatedServices: [101,102,105,104],
          sections: [],
        },
        {
          id: 113,
          title: 'Renteninformation',
          authority: 'Rentenamt',
          online: true,
          duration: 2,
          description: '',
          iconName: 'getMoney',
          doneBy: [],
          relatedServices: [101,102,103,105],
          sections: [],
        },
        {
          id: 114,
          title: 'Kitaplatz-Anmeldung',
          authority: 'Amt für Kinder, Jugend & Familie',
          online: false,
          duration: 7,
          description: '',
          iconName: 'school',
          doneBy: [],
          relatedServices: [101,102,103,104],
          sections: [],
        },
        {
          id: 115,
          title: 'Schwerbehinderten-Antrag',
          authority: 'Einwohnermeldeamt',
          online: false,
          duration: 7,
          description: '',
          iconName: 'checkAntrag',
          doneBy: [],
          relatedServices: [101,102,103,104],
          sections: [],
        },
        {
          id: 116,
          title: 'Gewerbezentralregister',
          authority: '',
          online: false,
          duration: 6,
          description: '',
          iconName: 'work',
          doneBy: [],
          relatedServices: [101,102,105,104],
          sections: [],
        },
        {
          id: 117,
          title: 'Lebenspartnerschafts-urkunde',
          authority: 'Landratsamt',
          online: true,
          duration: 2,
          description: '',
          iconName: 'certificateFile',
          doneBy: [],
          relatedServices: [101,102,103,105],
          sections: [],
        },
        {
          id: 118,
          title: 'Wohnungsgeber-bestätigung',
          authority: 'Einwohnermeldeamt',
          online: false,
          duration: 7,
          description: '',
          iconName: 'correct',
          doneBy: [],
          relatedServices: [101,102,103,104],
          sections: [],
        },
        {
          id: 119,
          title: 'Führungszeugnis',
          authority: 'Bürgerbüro',
          online: false,
          duration: 7,
          description: '',
          iconName: 'certificate',
          doneBy: [],
          relatedServices: [101,102,103,104],
          sections: [],
        },
        {
          id: 120,
          title: 'Feinstaubplakette',
          authority: 'Verkehrsamt',
          online: false,
          duration: 12,
          description: '',
          iconName: 'car',
          doneBy: [],
          relatedServices: [105,102,103,104],
          sections: [],
        },
        {
          id: 121,
          title: 'Geburtsurkunde',
          authority: 'Einwohnermeldeamt',
          online: true,
          duration: 6,
          description: '',
          iconName: 'children',
          doneBy: [],
          relatedServices: [101,105,103,104],
          sections: [],
        },
        {
          id: 122,
          title: 'Gewerbe-Anmeldung',
          authority: 'Finanzamt',
          online: false,
          duration: 6,
          description: '',
          iconName: 'spacecraft',
          doneBy: [],
          relatedServices: [101,102,105,104],
          sections: [],
        },
      ]
    },
    mutations: {
      SET_DONE (state, { userId, serviceId }) {
        const service = state.services.find(service => service.id == serviceId);
        service.doneBy.push(userId);
      },
    },
    actions: {
      setDone({ commit }, data) {
        const userId = data[0];
        const serviceId = data[1];
        commit('SET_DONE', { userId, serviceId });
      }
    },
    getters: {
      getAllServices: state => {
        return state.services;
      },
      getServiceById: (state) => (id) => {
        return state.services.find(service => service.id == id)
      },
      getServicesByIds: (state) => (ids) => {
        return state.services.filter(service => ids.includes(service.id))
      },
      getServicesByTitle: state => (searchTerm) => {
        return state.services.filter(service => service.title.toLowerCase().includes(searchTerm.toLowerCase()));
      }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/services.js